import * as React from "react";
import { SVGProps, memo } from "react";

const SvgAccounting = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={64} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.75 20a1.5 1.5 0 0 1 1.5-1.5H51.5A1.5 1.5 0 0 1 53 20v24.662a1.5 1.5 0 0 1-1.5 1.5H13.25a1.5 1.5 0 0 1-1.5-1.5V20Z"
      fill="#ECF9F2"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.188 20c0-1.14.923-2.063 2.062-2.063H51.5c1.14 0 2.063.924 2.063 2.063v24.662a2.063 2.063 0 0 1-2.063 2.062H13.25a2.062 2.062 0 0 1-2.063-2.062V20Zm2.062-.938a.937.937 0 0 0-.938.938v24.662c0 .517.42.937.938.937H51.5c.518 0 .938-.42.938-.937V20a.937.937 0 0 0-.938-.938H13.25Z"
      fill="#194D33"
    />

    <path
      d="M16.149 30.219a.914.914 0 0 1 .911.909v1.82a.911.911 0 0 1-.558.84.909.909 0 0 1-.99-.197.911.911 0 0 1-.264-.643v-1.81a.93.93 0 0 1 .26-.65.912.912 0 0 1 .293-.2.931.931 0 0 1 .348-.07ZM21.788 31.13a.911.911 0 1 0-1.823 0v1.82a.911.911 0 0 0 1.823 0v-1.82Z"
      fill="#fff"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.834 30.088a1.474 1.474 0 0 1 2.516 1.042v1.82a1.474 1.474 0 1 1-2.948 0v-1.82c0-.39.156-.766.432-1.042Zm1.042.693a.349.349 0 0 0-.349.35v1.82a.35.35 0 0 0 .698 0v-1.82a.349.349 0 0 0-.349-.35ZM15.334 30.088a1.474 1.474 0 0 1 2.516 1.042v1.82a1.474 1.474 0 1 1-2.948 0v-1.82c0-.39.156-.766.432-1.042Zm1.042.693a.349.349 0 0 0-.349.35v1.82a.35.35 0 0 0 .698 0v-1.82a.349.349 0 0 0-.349-.35Z"
      fill="#194D33"
    />

    <path
      d="M25.543 30.219a.902.902 0 0 1 .909.906v1.82a.912.912 0 0 1-1.823 0v-1.81a.917.917 0 0 1 .561-.85.933.933 0 0 1 .353-.066ZM30.192 30.219a.914.914 0 0 1 .915.909v1.82c-.001.24-.096.47-.264.642a.911.911 0 0 1-.645.264.9.9 0 0 1-.907-.906v-1.81a.91.91 0 0 1 .9-.92Z"
      fill="#fff"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.334 30.088a1.474 1.474 0 0 1 2.516 1.042v1.82a1.474 1.474 0 1 1-2.948 0v-1.82c0-.39.156-.766.432-1.042Zm1.042.693a.349.349 0 0 0-.349.35v1.82a.35.35 0 0 0 .698 0v-1.82a.349.349 0 0 0-.349-.35Z"
      fill="#194D33"
    />

    <path
      d="M34.866 30.219a.91.91 0 0 1 .911.909v1.82a.92.92 0 0 1-.263.643.913.913 0 0 1-1.557-.643v-1.81a.885.885 0 0 1 .069-.35.907.907 0 0 1 .194-.3.956.956 0 0 1 .285-.2.933.933 0 0 1 .36-.07Z"
      fill="#fff"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.728 30.804a.39.39 0 0 0-.105.077.343.343 0 0 0-.075.114l-.003.01a.324.324 0 0 0-.026.128V32.944a.35.35 0 0 0 .596.248.356.356 0 0 0 .1-.246v-1.82a.347.347 0 0 0-.348-.346h-.007a.369.369 0 0 0-.132.023Zm.14-1.148a1.495 1.495 0 0 0-.598.12 1.517 1.517 0 0 0-.452.318 1.474 1.474 0 0 0-.313.482c-.075.179-.112.37-.11.565v1.811a1.477 1.477 0 0 0 2.514 1.038l.006-.005c.272-.277.424-.649.425-1.036v-1.821a1.47 1.47 0 0 0-1.472-1.472ZM30.228 30.804a.39.39 0 0 0-.106.077.343.343 0 0 0-.073.114l-.004.01a.324.324 0 0 0-.026.128V32.944a.35.35 0 0 0 .596.248.356.356 0 0 0 .1-.246v-1.82a.347.347 0 0 0-.348-.346h-.007a.369.369 0 0 0-.132.023Zm.14-1.148a1.495 1.495 0 0 0-.598.12 1.517 1.517 0 0 0-.451.318 1.474 1.474 0 0 0-.314.482c-.075.179-.112.37-.11.565v1.811a1.477 1.477 0 0 0 2.514 1.038l.006-.005c.272-.277.424-.649.425-1.036v-1.821a1.47 1.47 0 0 0-1.472-1.472Z"
      fill="#194D33"
    />

    <path
      d="M39.534 30.219a.908.908 0 0 1 .839.558.9.9 0 0 1 .067.348v1.82a.911.911 0 0 1-1.82 0v-1.81a.91.91 0 0 1 .558-.85.957.957 0 0 1 .356-.066ZM44.185 30.219a.906.906 0 0 1 .853.566.897.897 0 0 1 .066.353v1.82a.912.912 0 0 1-1.82 0v-1.82a.923.923 0 0 1 .553-.848.882.882 0 0 1 .348-.071Z"
      fill="#fff"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.324 30.804a.343.343 0 0 0-.13-.023h-.01a.32.32 0 0 0-.126.026.345.345 0 0 0-.187.193.331.331 0 0 0-.025.13v1.81a.35.35 0 0 0 .696 0v-1.812a.332.332 0 0 0-.025-.13v-.002a.354.354 0 0 0-.072-.111.437.437 0 0 0-.121-.08Zm-.144-1.148c.196-.002.39.034.571.107l.012.005c.174.075.333.181.47.313l.008.009a1.48 1.48 0 0 1 .425 1.052v1.846a1.474 1.474 0 0 1-2.945-.03v-1.816a1.487 1.487 0 0 1 .42-1.045m1.039-.44a1.446 1.446 0 0 0-1.038.44M39.824 30.804a.343.343 0 0 0-.13-.023h-.01a.32.32 0 0 0-.126.026.345.345 0 0 0-.187.193.331.331 0 0 0-.025.13v1.81a.35.35 0 0 0 .696 0v-1.812a.332.332 0 0 0-.025-.13v-.002a.354.354 0 0 0-.072-.111.437.437 0 0 0-.121-.08Zm-.144-1.148c.196-.002.39.034.571.107l.012.005c.174.075.333.181.47.313l.008.009a1.48 1.48 0 0 1 .425 1.052v1.846a1.474 1.474 0 0 1-2.945-.03v-1.816a1.487 1.487 0 0 1 .42-1.045m1.039-.44a1.446 1.446 0 0 0-1.038.44"
      fill="#194D33"
    />

    <path d="M49.768 31.081a.912.912 0 0 0-1.82 0v1.82a.911.911 0 0 0 1.82 0v-1.82Z" fill="#fff" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.844 30.06a1.474 1.474 0 0 1 2.486 1.021v1.85a1.474 1.474 0 0 1-2.945-.03v-1.82l.001-.03c.02-.377.184-.731.458-.99Zm1.014.721a.35.35 0 0 0-.348.319v1.783a.348.348 0 0 0 .696 0V31.1a.349.349 0 0 0-.348-.319Z"
      fill="#194D33"
    />

    <path
      d="M15.953 22.938a.631.631 0 0 0-.453.179.645.645 0 0 0-.198.445v3.3a.705.705 0 0 0 .053.243.69.69 0 0 0 .142.203c.06.058.132.104.21.134a.6.6 0 0 0 .246.042h5.987a.6.6 0 0 0 .245-.042.642.642 0 0 0 .406-.58v-3.3a.643.643 0 0 0-.65-.624h-5.988Z"
      fill="#fff"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.957 22.375h5.98a1.205 1.205 0 0 1 1.217 1.187V26.883c-.006.15-.038.298-.096.437l-.006.013a1.206 1.206 0 0 1-.663.633 1.162 1.162 0 0 1-.457.08h-5.97a1.162 1.162 0 0 1-.458-.08 1.176 1.176 0 0 1-.4-.255l-.002-.003a1.249 1.249 0 0 1-.267-.388 1.267 1.267 0 0 1-.095-.437v-3.338a1.208 1.208 0 0 1 1.217-1.17Zm-.015 1.125a.07.07 0 0 0-.05.02l-.002.002a.083.083 0 0 0-.025.053v3.273c0 .011.003.021.006.032.005.01.012.018.02.026.005.004.01.008.016.01l.009.003a.04.04 0 0 0 .015.003H21.962c.005 0 .01 0 .015-.003l.009-.003a.051.051 0 0 0 .017-.011l.003-.003a.08.08 0 0 0 .015-.02.139.139 0 0 0 .008-.034v-3.274a.08.08 0 0 0-.081-.074h-6.005Z"
      fill="#194D33"
    />

    <path
      d="M49.273 38.54H37.348a.566.566 0 1 0 0 1.13h11.917a.566.566 0 0 0 0-1.13h.008ZM49.322 40.79h-7.85a.566.566 0 1 0 0 1.13h7.85a.566.566 0 1 0 0-1.13Z"
      fill="#194D33"
    />
  </svg>
);

const Memo = memo(SvgAccounting);

export default Memo;
